import React from 'react'
import Bulk_Update from './Bulk_Update'

export default function index() {
  return (
      < Bulk_Update/>
  )
}
